import type { MachineModelHealthStatus } from "@octopusdeploy/octopus-server-client";
import { MachineModelHealthStatusValues } from "@octopusdeploy/octopus-server-client";

export function machineHealthStatusToStatusBadgeStatus(healthStatus: MachineModelHealthStatus) {
    switch (healthStatus) {
        case MachineModelHealthStatusValues.Healthy:
            return "healthy";
        case MachineModelHealthStatusValues.HasWarnings:
            return "healthy-with-warnings";
        case MachineModelHealthStatusValues.Unhealthy:
            return "unhealthy";
        case MachineModelHealthStatusValues.Unavailable:
            return "unavailable";
        default:
            return "unknown";
    }
}
